module.exports = __webpack_public_path__ + "img/header-coin-history.3472d941.svg";